import React from "react";
import Container from "../../components/Container/Container";
function Test1() {
  return (
    <Container name="Page test 1">
      <div className="card card-custom">this is test 1 page</div>
    </Container>
  );
}

export default Test1;
